import type { ReactNode } from "react";
import styles from "./PreferenceCard.module.css";

interface PreferenceCardProps {
  label: string;
  value: string | null;
  description?: string;
  icon?: ReactNode;
  emptyText?: string;
  tags?: string[];
  variant?: "default" | "meter";
  meterLevel?: "simple" | "moderate" | "complex" | "basic" | "intermediate" | "advanced";
  meterLabels?: [string, string, string];
}

export function PreferenceCard({
  label,
  value,
  description,
  icon,
  emptyText = "Not set",
  tags,
  variant = "default",
  meterLevel,
  meterLabels,
}: PreferenceCardProps) {
  const getMeterFillClass = () => {
    if (!meterLevel) return "";
    const classMap: Record<string, string> = {
      simple: styles.meterFillSimple,
      moderate: styles.meterFillModerate,
      complex: styles.meterFillComplex,
      basic: styles.meterFillBasic,
      intermediate: styles.meterFillIntermediate,
      advanced: styles.meterFillAdvanced,
    };
    return classMap[meterLevel] || "";
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        {icon && <span className={styles.icon}>{icon}</span>}
        <span className={styles.label}>{label}</span>
      </div>

      {value ? (
        <>
          <span className={styles.value}>{value}</span>
          {variant === "meter" && meterLevel && (
            <div className={styles.meterWrapper}>
              <div className={styles.meter}>
                <div className={`${styles.meterFill} ${getMeterFillClass()}`} />
              </div>
              {meterLabels && (
                <div className={styles.meterLabels}>
                  <span>{meterLabels[0]}</span>
                  <span>{meterLabels[1]}</span>
                  <span>{meterLabels[2]}</span>
                </div>
              )}
            </div>
          )}
        </>
      ) : (
        <span className={styles.emptyState}>{emptyText}</span>
      )}

      {description && <p className={styles.description}>{description}</p>}

      {tags && tags.length > 0 && (
        <div className={styles.tags}>
          {tags.map((tag) => (
            <span key={tag} className={styles.tag}>
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
